export const RECRUITMENT_NUMBER_OPTIONS = [
  {
    label: "〜5名",
    value: 0, // minの値。PopoverSelectBoxのOptionPropsの構造上valueとする
    max: 5
  },
  {
    label: "6〜10名",
    value: 6,
    max: 10
  },
  {
    label: "11〜50名",
    value: 11,
    max: 50
  },
  {
    label: "51〜100名",
    value: 51,
    max: 100
  },
  {
    label: "101名以上",
    value: 101,
    max: undefined
  }
] as const;
